module.exports = __webpack_public_path__ + "img/jb2.f26b9dd.png";